import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import { initializeApp } from "firebase/app";

// testing google sso
const firebaseConfig = {
    apiKey: "AIzaSyAzTUKy9moANcsyAmnaW_i9lUOsqbmIAE8",
    authDomain: "branch-dashboard.firebaseapp.com",
    projectId: "branch-dashboard",
    storageBucket: "branch-dashboard.appspot.com",
    messagingSenderId: "1021068762039",
    appId: "1:1021068762039:web:eb6a606f6fbc4538a2e632",
    measurementId: "G-PNSNSN5Y7K"
};

// production google sso

// const firebaseConfig = {
//     apiKey: "AIzaSyBXPDwPt576ZnH_w4hhtMaLR7sDsXNQkjs",
//     authDomain: "branch-101bf.firebaseapp.com",
//     projectId: "branch-101bf",
//     storageBucket: "branch-101bf.appspot.com",
//     messagingSenderId: "938180884923",
//     appId: "1:938180884923:web:e40b9be40ff6204e566c9e",
//     measurementId: "G-7QY3S9ENCM"
//   };

initializeApp(firebaseConfig);
Vue.config.productionTip = false

new Vue({
    vuetify,
    router,
    render: h => h(App)
}).$mount('#app')